<template>
  <lazy-gameserver-index-wrapper v-if="slug === 'index'" />
  <lazy-landing-page-wrapper v-else :slug="slug" />
</template>

<script lang="ts" setup>
defineOptions({
  name: 'GameserverLandingPage',
});

const route = useRoute();
const slug = computed(() => route.params.slug as string);

false && /*#__PURE__*/ defineI18nRoute({
  paths: {
    de: '/gameserver/[slug]',
    en: '/gameserver/[slug]',
    pt: '/servidor-de-jogos/[slug]',
    fr: '/serveur-de-jeu/[slug]',
    nl: '/gameserver/[slug]',
    it: '/server-di-gioco/[slug]',
    ja: '/gameserver/[slug]',
    pl: '/serwery-gier/[slug]',
    // ru: '/gameserver/[slug]',
    es: '/gameserver/[slug]',
    zh: '/gameserver/[slug]',
  },
});
</script>
